var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"news-wrapper is-marged-bottom"},_vm._l((_vm.news),function(newsObject){return _c('div',{staticClass:"notification is-warning"},[_c('h3',{staticClass:"title is-h3"},[_vm._v(_vm._s(newsObject.title))]),_vm._v(" "),_c('div',{domProps:{"innerHTML":_vm._s(newsObject.copy)}})])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }